import {createStore, applyMiddleware, combineReducers} from 'redux'
import {reducer as formReducer} from 'redux-form'
import thunk from 'redux-thunk'
import textReducer from './reducers/text'
import authReducer from './reducers/auth'
import editReducer from './reducers/edit'
import userReducer from './reducers/users'
import protectedDataReducer from './reducers/protected-data'
import {loadAuthToken} from './local-storage'
import {setAuthToken} from './actions/auth'

const store = createStore(
    combineReducers({
        user: userReducer,
    	edit: editReducer,
    	text: textReducer,
        form: formReducer,
        auth: authReducer,
        protectedData: protectedDataReducer
    }),
    applyMiddleware(thunk)
);

const authToken = loadAuthToken()

if (authToken) {
    const token = authToken;
    store.dispatch(setAuthToken(token));
}

export default store;



// WEBPACK FOOTER //
// ./src/store.js